import { type KeyboardEvent, type Ref, useId, useState } from 'react';
import styles from './AuthForm.module.css';

/** Campo de contraseña con «Mostrar» y aviso de Bloq Mayús. */
export function PasswordField({ label, value, onChange, autoComplete, hint, invalid, inputRef }: {
  label: string;
  inputRef?: Ref<HTMLInputElement>;
  value: string;
  onChange: (value: string) => void;
  autoComplete: 'current-password' | 'new-password';
  hint?: string;
  invalid?: boolean;
}) {
  const id = useId();
  const [visible, setVisible] = useState(false);
  const [capsLock, setCapsLock] = useState(false);
  const detectCaps = (event: KeyboardEvent<HTMLInputElement>) => setCapsLock(event.getModifierState('CapsLock'));
  const describedBy = [hint ? `${id}-hint` : null, capsLock ? `${id}-caps` : null].filter(Boolean).join(' ') || undefined;

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>{label}</label>
      <div className={styles.passwordBox}>
        <input ref={inputRef} id={id} className={styles.input} type={visible ? 'text' : 'password'} autoComplete={autoComplete}
          value={value} spellCheck={false} aria-invalid={invalid || undefined} aria-describedby={describedBy}
          onChange={(event) => onChange(event.target.value)} onKeyDown={detectCaps} onKeyUp={detectCaps}
          onBlur={() => setCapsLock(false)} />
        <button type="button" className={styles.reveal} aria-pressed={visible}
          aria-label={visible ? `Ocultar ${label.toLowerCase()}` : `Mostrar ${label.toLowerCase()}`}
          onClick={() => setVisible((current) => !current)}>
          {visible ? 'Ocultar' : 'Mostrar'}
        </button>
      </div>
      {hint && <p id={`${id}-hint`} className={styles.hint}>{hint}</p>}
      {capsLock && <p id={`${id}-caps`} className={styles.caps}>Bloq Mayús está activado.</p>}
    </div>
  );
}
